import { Delete } from '@workwave-tidal/core/icons'
import { useMemo } from 'react'

import { preview } from '@/components/form/preview'
import { useReadOnlyTooltipData } from '@/components/smartUtils/plan/ReadOnlyTooltip'
import { parseRecurrence } from '@/server-data'

import { useDeleteDriverAssignmentModal } from '../../../../../modals/DeleteDriverAssignmentModal'
import { useActions } from '../hooks/useActions'
import { useTexts } from '../hooks/useTexts'

interface Props {
  driverAssignments: uui.domain.client.rm.DriverAssignmentsWithId[]
}

export function Header(props: Props) {
  const { driverAssignments } = props
  const actions = useActions()
  const texts = useTexts()
  const { Modal: DeleteDriverAssignmentModal } = useDeleteDriverAssignmentModal()

  // Ignore courier read-only reason, but respect other read-only reasons
  const { preventEditing, title } = useReadOnlyTooltipData(undefined, ['courier'])

  const driverAssignmentIds = useMemo(() => driverAssignments.map(da => da.id), [driverAssignments])

  // Check if any assignment is a default "Normal Day" (type === 'any')
  const hasDefaultAssignment = useMemo(
    () =>
      driverAssignments.some(da => {
        const recurrence = parseRecurrence(da.id)
        return recurrence?.type === 'any'
      }),
    [driverAssignments],
  )

  const deleteDisabled = hasDefaultAssignment || preventEditing

  return (
    <>
      <preview.Header
        title={texts.bulkTitle(driverAssignments.length)}
        testId="driver-assignment-bulk-view-header"
        onClose={actions.onReset}
      >
        <preview.ActionBar>
          <preview.ActionBarItem
            icon={<Delete />}
            onClick={actions.onDelete}
            label={texts.delete}
            tooltip={
              hasDefaultAssignment ? texts.deleteNormalDay : preventEditing ? title : texts.delete
            }
            testId="setup-vehicleassignment__bulkdelete"
            data-trackid="setup-vehicleassignment__bulkdelete"
            disableWhenReadOnly={false}
            disabled={deleteDisabled}
          />
        </preview.ActionBar>
      </preview.Header>

      <DeleteDriverAssignmentModal driverAssignmentIds={driverAssignmentIds} />
    </>
  )
}
